import { render, staticRenderFns } from "./OvertimeDetail.vue?vue&type=template&id=d9979dc4&"
import script from "./OvertimeDetail.vue?vue&type=script&lang=js&"
export * from "./OvertimeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports